









































































































































































































































































import {Component, Vue, Watch} from 'vue-property-decorator';
import Datepicker from '@/components/datepicker/DatePicker.vue';
import {loginModule} from '@/store/authentication/login';
import {viewEditingStateModule} from '@/store/state/viewEditingState';
import moment from 'moment';
import {ValidationResult} from '@/type/validation/result';
import {
  ハンディ棚卸情報型,
  バラ単位区分型,
  並順区分型,
  有効期限あり棚卸明細行型,
  棚卸作成依頼型,
  棚卸保存依頼型,
  棚卸入力バリデータ一覧,
  棚卸再計算依頼型,
  棚卸取得依頼型,
  棚卸情報型,
  棚卸明細型,
  棚卸明細行保存依頼型,
  棚卸明細行再計算依頼型,
  棚卸明細行確定依頼型,
  棚卸検索条件バリデータ一覧,
  棚卸検索条件型,
  棚卸確定依頼型,
  棚卸絞込み依頼型, 棚卸絞込条件バリデータ一覧,
  棚卸部署型,
  棚卸部署概要型,
  棚名有無区分型,
  理論在庫有無区分型,
  使用区分型,
} from '@/type/stocktaking/types';
import RegisterStocktakingDataRow from '@/views/stocktaking/fragments/RegisterStocktakingDataRow.vue';

import {入力状態} from '@/type/stocktaking/inputStatus';

import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
import IconButton from '@/components/atom/button/IconButton.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import CompleteDialog from '@/components/atom/dialog/CompleteDialog.vue';
import {progress} from '@/script/progress';
import {StocktakingApi} from '@/infrastructure/api/stocktaking/stocktakingApi';
import {StandardStocktakingApi} from '@/infrastructure/api/stocktaking/standardStocktakingApi';
import {GoryoukakuStocktakingApi} from '@/infrastructure/api/custom/goryoukaku/stocktaking/goryoukakuStocktakingApi';

@Component({
  components: {
    CompleteDialog,
    Datepicker,
    ButtonPanel,
    IconButton,
    AlertDialog,
    ConfirmDialog,
    NormalButton,
    RegisterStocktakingDataRow,
  },
})
export default class RegisterStocktaking extends Vue {
  // data
  棚卸部署一覧: 棚卸部署型[] = [];
  取得済棚卸情報: 棚卸情報型 | null = null;
  取得済棚卸明細: 棚卸明細型[] = [];
  取込可能ハンディ棚卸情報件数: number = 0;
  未確定棚卸日付: Date | null = null;

  棚卸検索条件: 棚卸検索条件型 = new 棚卸検索条件型();
  取得時棚卸検索条件: 棚卸検索条件型 = new 棚卸検索条件型();

  棚名有無区分一覧 = Object.keys(棚名有無区分型);
  理論在庫有無区分一覧 = Object.keys(理論在庫有無区分型);
  使用区分一覧 = Object.keys(使用区分型);
  // TODO selectのoption直書きで使われていないがこれを使った方がよさそう
  並順区分一覧 = Object.keys(並順区分型);

  アラートメッセージ: string | string[] | null = null;
  完了メッセージ: string | string[] | null = null;

  api!: StocktakingApi;

  // 検索/絞り込みなど棚卸取得前後で明細行の key 値に同一の値を振らないように使う
  棚卸取得回数: number = 0;

  // computed
  get 管理者である(): boolean {
    return loginModule.管理者である;
  }

  get 箱管理である(): boolean {
    return loginModule.箱管理である;
  }

  get バラ管理である(): boolean {
    return loginModule.バラ管理である;
  }

  get 棚卸有効期限を表示する(): boolean {
    return loginModule.棚卸有効期限を表示する;
  }

  get 棚卸有効期限を表示しない(): boolean {
    return loginModule.棚卸有効期限を表示しない;
  }

  get 譲受カラムを表示する(): boolean {
    return loginModule.譲渡譲受を利用する;
  }

  get 函館五稜郭病院仕様である(): boolean {
    return loginModule.函館五稜郭病院仕様である;
  }

  get 入力状態(): 入力状態 {
    if (this.取得済棚卸情報 == null) {
      return 入力状態.未表示;
    }
    if (this.取得済棚卸情報.ヘッダー.確定状態 === '未確定') {
      if (this.取得済棚卸明細.length === 0) {
        return 入力状態.未確定表示中_明細なし;
      } else {
        return 入力状態.未確定表示中_明細あり;
      }
    } else {
      if (this.取得済棚卸明細.length === 0) {
        return 入力状態.確定済表示中_明細なし;
      } else {
        return 入力状態.確定済表示中_明細あり;
      }
    }
  }

  get is未表示(): boolean {
    return this.入力状態 === 入力状態.未表示;
  }

  get is未確定表示中(): boolean {
    return this.入力状態 === 入力状態.未確定表示中_明細あり || this.入力状態 === 入力状態.未確定表示中_明細なし;
  }

  get is未確定表示中_明細あり(): boolean {
    return this.入力状態 === 入力状態.未確定表示中_明細あり;
  }

  get is確定済表示中(): boolean {
    return this.入力状態 === 入力状態.確定済表示中_明細あり || this.入力状態 === 入力状態.確定済表示中_明細なし;
  }

  get is表示中_明細あり(): boolean {
    return this.入力状態 === 入力状態.未確定表示中_明細あり || this.入力状態 === 入力状態.確定済表示中_明細あり;
  }

  get 在庫場所選択可能(): boolean {
    return this.管理者である && this.集計条件入力可能;
  }

  get 集計条件入力可能(): boolean {
    return this.is未表示;
  }

  get 棚卸表示可能(): boolean {
    return this.集計条件入力可能;
  }

  get 検索条件設定可能(): boolean {
    return this.is未表示 === false;
  }

  get 検索開始可能(): boolean {
    return this.is未表示 === false;
  }

  get クリア可能(): boolean {
    return this.is未表示 === false;
  }

  get 保存可能(): boolean {
    return this.is未確定表示中_明細あり;
  }

  get 確定可能(): boolean {
    return this.is未確定表示中;
  }

  get 棚卸取消可能(): boolean {
    return this.is未確定表示中_明細あり;
  }

  get HT取込可能(): boolean {
    return this.is未確定表示中_明細あり && (0 < this.取込可能ハンディ棚卸情報件数);
  }

  get Excel出力可能(): boolean {
    return this.is表示中_明細あり;
  }

  get 印刷可能(): boolean {
    return this.is表示中_明細あり;
  }

  get 再計算可能(): boolean {
    return this.is未確定表示中_明細あり;
  }

  get 複写可能(): boolean {
    return this.is未確定表示中_明細あり;
  }

  // watched properties
  @Watch('棚卸検索条件.在庫場所')
  在庫場所が変更された(): void {
    progress(this.最新棚卸日付の取得);
  }

  @Watch('取得済棚卸情報')
  取得済棚卸情報が変更された(): void {
    this.取得済棚卸明細の設定();
    viewEditingStateModule.画面の編集を終了する();
  }

  // methods
  async 初期化処理(): Promise<void> {
    viewEditingStateModule.初期化する();
    await progress(this.棚卸部署一覧の取得);
    await progress(this.最新棚卸日付の取得);
  }

  アラートダイアログを表示する(メッセージ: string | string[]): void {
    if (typeof メッセージ === 'string') {
      this.アラートメッセージ = [メッセージ];
    } else {
      this.アラートメッセージ = メッセージ;
    }
    this.$modal.show('アラート');
  }

  完了ダイアログを表示する(メッセージ: string | string[]): void {
    if (typeof メッセージ === 'string') {
      this.完了メッセージ = [メッセージ];
    } else {
      this.完了メッセージ = メッセージ;
    }
    this.$modal.show('完了ダイアログ');
  }

  確認ダイアログを開く(name: string): void {
    this.$modal.show(name);
  }

  確認ダイアログを閉じる(name: string): void {
    this.$modal.hide(name);
  }

  検索条件の入力検証(): ValidationResult {
    const checker = new ValidationResult(棚卸検索条件バリデータ一覧);
    checker.validate(this.棚卸検索条件);
    return checker;
  }

  検索条件エラー判定(項目名: string): boolean {
    const result = this.検索条件の入力検証();
    return result.getErrors
      .filter((error) => error.name === 項目名)
      .length !== 0;
  }

  絞込条件の入力検証(): ValidationResult {
    const checker = new ValidationResult(棚卸絞込条件バリデータ一覧);
    checker.validate(this.棚卸検索条件);
    return checker;
  }

  絞込条件エラー判定(項目名: string): boolean {
    const result = this.絞込条件の入力検証();
    return result.getErrors
        .filter((error) => error.name === 項目名)
        .length !== 0;
  }

  棚卸入力の入力検証(): ValidationResult {
    const checker = new ValidationResult(棚卸入力バリデータ一覧);
    checker.validateList(this.取得済棚卸明細);
    return checker;
  }

  async 棚卸部署一覧の取得(): Promise<void> {
    this.棚卸部署一覧 = await this.api.棚卸部署一覧を取得する();
    if (this.棚卸部署一覧 !== undefined && 0 < this.棚卸部署一覧.length) {
      this.棚卸検索条件.在庫場所 = this.棚卸部署一覧[0].部署コード;
    }
  }

  async 最新棚卸日付の取得(): Promise<void> {
    if (this.棚卸検索条件.在庫場所 === null) {
      return;
    }

    try {
      const 棚卸部署概要: 棚卸部署概要型 = await this.api.棚卸部署概要を取得する(this.棚卸検索条件.在庫場所);
      this.棚卸検索条件.棚卸年月日 = 棚卸部署概要.最新棚卸日付;
    } catch (error) {
      this.APIアラートメッセージを表示する(error);
    }
  }

  async 未確定棚卸日付を取得する(): Promise<void> {
    if (this.棚卸検索条件.在庫場所 === null) {
      return;
    }

    try {
      const 棚卸部署概要: 棚卸部署概要型 = await this.api.棚卸部署概要を取得する(this.棚卸検索条件.在庫場所);
      this.未確定棚卸日付 = 棚卸部署概要.未確定棚卸日付;
    } catch (error) {
      this.APIアラートメッセージを表示する(error);
    }
  }

  async 取込可能ハンディ棚卸情報件数の取得(): Promise<void> {
    if (this.取得済棚卸情報 === null) {
      this.取込可能ハンディ棚卸情報件数 = 0;
      return;
    }

    try {
      const ハンディ棚卸情報: ハンディ棚卸情報型
        = await this.api.HT棚卸情報を取得する(this.取得済棚卸情報.ヘッダー.棚卸番号);
      this.取込可能ハンディ棚卸情報件数 = ハンディ棚卸情報.取込可能件数;
    } catch (error) {
      this.APIアラートメッセージを表示する(error);
    }
  }

  取得済棚卸明細の設定(): void {
    if (this.取得済棚卸情報 === null) {
      this.取得済棚卸明細 = [];
      return;
    }
    this.棚卸取得回数++;
    this.取得済棚卸明細 = this.取得済棚卸情報.明細一覧;
  }

  async 棚卸を表示する(): Promise<void> {
    const result = this.検索条件の入力検証();
    if (result.hasErrors) {
      this.アラートダイアログを表示する(result.getMessages());
      return;
    }

    await progress(this.棚卸情報の表示);
  }

  async 棚卸情報の表示(): Promise<void> {
    await this.棚卸情報の取得()
        .then((response: any) => {
          this.取込可能ハンディ棚卸情報件数の取得();
        })
        .catch((errorStatus) => {
          if (errorStatus === 404) {
            this.未確定棚卸日付を取得する().then(() => {
              if (this.未確定棚卸日付 !== null) {
                this.アラートダイアログを表示する([
                  '指定条件の棚卸情報はありません。',
                  'また、前回の棚卸が確定されていませんので、指定日で棚卸は開始できません。',
                ]);
                return;
              }

              this.確認ダイアログを開く('棚卸入力開始確認ダイアログ');
            });
          }
        });
  }

  async 棚卸情報の取得(): Promise<void> {
    const 棚卸取得依頼: 棚卸取得依頼型 = {
      部署コード: this.棚卸検索条件.在庫場所,
      棚卸年月日: this.customFormat(this.棚卸検索条件.棚卸年月日),
    };

    this.棚卸情報取得時の検索条件を保持する();

    try {
      this.取得済棚卸情報 = await this.api.棚卸を取得する(棚卸取得依頼);
    } catch (response) {
      throw response.status;
    }
  }

  棚卸情報取得時の検索条件を保持する(): void {
    this.取得時棚卸検索条件.在庫場所 = this.棚卸検索条件.在庫場所;
    this.取得時棚卸検索条件.棚卸年月日 = this.棚卸検索条件.棚卸年月日;
    this.取得時棚卸検索条件.棚名検索条件 = this.棚卸検索条件.棚名検索条件;
    this.取得時棚卸検索条件.棚番号検索条件 = this.棚卸検索条件.棚番号検索条件;
    this.取得時棚卸検索条件.棚名有無検索条件 = this.棚卸検索条件.棚名有無検索条件;
    this.取得時棚卸検索条件.理論在庫有無検索条件 = this.棚卸検索条件.理論在庫有無検索条件;
    this.取得時棚卸検索条件.使用区分検索条件 = this.棚卸検索条件.使用区分検索条件;
    this.取得時棚卸検索条件.メーカー名検索条件 = this.棚卸検索条件.メーカー名検索条件;
    this.取得時棚卸検索条件.商品名カナ検索条件 = this.棚卸検索条件.商品名カナ検索条件;
    this.取得時棚卸検索条件.並順区分検索条件 = this.棚卸検索条件.並順区分検索条件;
  }

  async 棚卸を絞込む(): Promise<void> {
    const result = this.絞込条件の入力検証();
    if (result.hasErrors) {
      this.アラートダイアログを表示する(result.getMessages());
      return;
    }

    await progress(this.棚卸情報の絞込み);
  }

  async 棚卸情報の絞込み(): Promise<void> {
    if (viewEditingStateModule.画面を編集中である === false) {
      await this.棚卸情報の絞込み検索();
      return;
    }

    this.確認ダイアログを開く('絞込み確認ダイアログ');
  }

  async 確認ダイアログを閉じて棚卸情報の絞込み検索(): Promise<void> {
    this.確認ダイアログを閉じる('絞込み確認ダイアログ');
    await progress(this.棚卸情報の絞込み検索);
  }

  async 棚卸情報の絞込み検索(): Promise<void> {
    const 棚卸絞込み依頼: 棚卸絞込み依頼型 = {
      部署コード: this.棚卸検索条件.在庫場所,
      棚卸年月日: this.customFormat(this.棚卸検索条件.棚卸年月日),
      棚名検索条件: this.棚卸検索条件.棚名検索条件,
      棚番号検索条件: this.棚卸検索条件.棚番号検索条件,
      棚名有無検索条件: this.棚卸検索条件.棚名有無検索条件,
      理論在庫有無検索条件: this.棚卸検索条件.理論在庫有無検索条件,
      使用区分検索条件: this.棚卸検索条件.使用区分検索条件,
      商品名カナ検索条件: this.棚卸検索条件.商品名カナ検索条件,
      メーカー名検索条件: this.棚卸検索条件.メーカー名検索条件,
      並順区分検索条件: this.棚卸検索条件.並順区分検索条件,
    };

    this.棚卸情報取得時の検索条件を保持する();

    try {
      this.取得済棚卸情報 = await this.api.棚卸を絞り込む(棚卸絞込み依頼);
    } catch (error) {
      this.APIアラートメッセージを表示する(error);
    }
  }

  async 確認ダイアログを閉じて棚卸を作成する(): Promise<void> {
    this.確認ダイアログを閉じる('棚卸入力開始確認ダイアログ');
    await progress(this.棚卸情報の作成);
  }

  async 棚卸情報の作成(): Promise<void> {
    if (this.棚卸検索条件.棚卸年月日 === null) {
      return;
    }

    const 棚卸情報作成依頼: 棚卸作成依頼型 = {
      部署コード: this.棚卸検索条件.在庫場所,
      棚卸年月日: this.customFormat(this.棚卸検索条件.棚卸年月日),
    };
    try {
      this.取得済棚卸情報 = await this.api.棚卸を作成する(棚卸情報作成依頼);
      this.完了ダイアログを表示する('棚卸情報の作成が完了しました。');
    } catch (error) {
      this.APIアラートメッセージを表示する(error);
    }
  }

  棚卸情報の保存確認(): void {
    const result = this.棚卸入力の入力検証();
    if (result.hasErrors) {
      this.アラートダイアログを表示する(result.getMessages(true));
      return;
    }

    this.確認ダイアログを開く('保存確認ダイアログ');
  }

  async 確認ダイアログを閉じて棚卸を保存する(): Promise<void> {
    this.確認ダイアログを閉じる('保存確認ダイアログ');
    await progress(this.棚卸情報の保存);
  }

  async 棚卸情報の保存(): Promise<void> {
    if (this.取得済棚卸情報 === null) {
      return;
    }

    const 棚卸明細保存依頼: 棚卸明細行保存依頼型[] =
      this.取得済棚卸情報.明細一覧.map((明細: 棚卸明細型) => {
        return {
          商品コード: 明細.棚卸商品.商品コード,
          有効期限: this.customFormat(明細.棚卸在庫.有効期限),
          在庫区分: 明細.棚卸在庫.在庫区分,
          棚名: 明細.棚番設定.棚名,
          棚番号: 明細.棚番設定.棚番号,
          箱数: 明細.棚卸在庫.実在庫.箱数,
          バラ数: 明細.棚卸在庫.実在庫.バラ数,
          更新バージョン: 明細.更新バージョン,
          理論在庫換算数: 明細.棚卸在庫.理論在庫.在庫換算数,
          実在庫換算数: 明細.棚卸在庫.実在庫.在庫換算数,
        };
      });

    const 有効期限あり棚卸明細: 有効期限あり棚卸明細行型[] =
      this.取得済棚卸情報.有効期限あり明細一覧.map((明細: 棚卸明細型) => {
        return {
          商品コード: 明細.棚卸商品.商品コード,
          有効期限: this.customFormat(明細.棚卸在庫.有効期限),
          在庫区分: 明細.棚卸在庫.在庫区分,
          棚名: 明細.棚番設定.棚名,
          棚番号: 明細.棚番設定.棚番号,
          理論在庫換算数: 明細.棚卸在庫.理論在庫.在庫換算数,
          更新バージョン: 明細.更新バージョン,
        };
      });

    const 棚卸保存依頼: 棚卸保存依頼型 = {
      棚卸番号: this.取得済棚卸情報.ヘッダー.棚卸番号,
      部署コード: this.取得済棚卸情報.ヘッダー.部署コード,
      棚卸日付: this.customFormat(this.取得済棚卸情報.ヘッダー.棚卸日付),
      棚卸明細: 棚卸明細保存依頼,
      有効期限あり棚卸明細,
    };

    try {
      await this.api.棚卸を保存する(棚卸保存依頼);
      this.クリア();
      this.完了ダイアログを表示する('棚卸情報の保存が完了しました');
    } catch (error) {
      this.APIアラートメッセージを表示する(error);
    }
  }

  棚卸情報の確定確認(): void {
    const result = this.棚卸入力の入力検証();
    if (result.hasErrors) {
      this.アラートダイアログを表示する(result.getMessages(true));
      return;
    }
    this.確認ダイアログを開く('確定確認ダイアログ');
  }

  async 確認ダイアログを閉じて棚卸を確定する(): Promise<void> {
    this.確認ダイアログを閉じる('確定確認ダイアログ');
    await progress(this.棚卸情報の確定);
  }

  async 棚卸情報の確定(): Promise<void> {
    if (this.取得済棚卸情報 === null) {
      return;
    }

    const 棚卸明細確定依頼: 棚卸明細行確定依頼型[] =
      this.取得済棚卸情報.明細一覧.map((明細: 棚卸明細型) => {
        return {
          商品コード: 明細.棚卸商品.商品コード,
          有効期限: this.customFormat(明細.棚卸在庫.有効期限),
          在庫区分: 明細.棚卸在庫.在庫区分,
          棚名: 明細.棚番設定.棚名,
          棚番号: 明細.棚番設定.棚番号,
          箱数: 明細.棚卸在庫.実在庫.箱数,
          バラ数: 明細.棚卸在庫.実在庫.バラ数,
          更新バージョン: 明細.更新バージョン,
          理論在庫換算数: 明細.棚卸在庫.理論在庫.在庫換算数,
          実在庫換算数: 明細.棚卸在庫.実在庫.在庫換算数,
        };
      });

    const 有効期限あり棚卸明細: 有効期限あり棚卸明細行型[] =
      this.取得済棚卸情報.有効期限あり明細一覧.map((明細: 棚卸明細型) => {
        return {
          商品コード: 明細.棚卸商品.商品コード,
          有効期限: this.customFormat(明細.棚卸在庫.有効期限),
          在庫区分: 明細.棚卸在庫.在庫区分,
          棚名: 明細.棚番設定.棚名,
          棚番号: 明細.棚番設定.棚番号,
          理論在庫換算数: 明細.棚卸在庫.理論在庫.在庫換算数,
          更新バージョン: 明細.更新バージョン,
        };
      });

    const 棚卸確定依頼: 棚卸確定依頼型 = {
      棚卸明細: 棚卸明細確定依頼,
      有効期限あり棚卸明細,
    };

    try {
      await this.api.棚卸を確定する(this.取得済棚卸情報.ヘッダー.棚卸番号, 棚卸確定依頼);
      this.クリア();
      this.完了ダイアログを表示する('棚卸情報の確定が完了しました。');
    } catch (error) {
      this.APIアラートメッセージを表示する(error);
    }
  }

  棚卸情報の取消確認(): void {
    this.確認ダイアログを開く('取消確認ダイアログ');
  }

  async 確認ダイアログを閉じて棚卸を取消する(): Promise<void> {
    this.確認ダイアログを閉じる('取消確認ダイアログ');
    await progress(this.棚卸情報の取消);
  }

  async 棚卸情報の取消(): Promise<void> {
    if (this.取得済棚卸情報 === null) {
      return;
    }

    try {
      await this.api.棚卸を取り消す(this.取得済棚卸情報.ヘッダー.棚卸番号);
      this.クリア();
      this.完了ダイアログを表示する('棚卸情報の削除が完了しました。');
    } catch (error) {
      this.APIアラートメッセージを表示する(error);
    }
  }

  HT棚卸情報の取込確認(): void {
    this.確認ダイアログを開く('HT取込確認ダイアログ');
  }

  async 確認ダイアログを閉じてHT棚卸を取り込む(): Promise<void> {
    this.確認ダイアログを閉じる('HT取込確認ダイアログ');
    await progress(this.HT棚卸情報の取込);
  }

  async HT棚卸情報の取込(): Promise<void> {
    if (this.取得済棚卸情報 === null) {
      return;
    }

    try {
      await this.api.HT棚卸情報を取り込む(this.取得済棚卸情報.ヘッダー.棚卸番号);
      this.クリア();
      this.完了ダイアログを表示する('ハンディからの棚卸データ取込が完了しました。');
    } catch (error) {
      this.APIアラートメッセージを表示する(error);
    }
  }

  棚卸一覧表の出力確認(): void {
    const result = this.棚卸入力の入力検証();
    if (result.hasErrors) {
      this.アラートダイアログを表示する(result.getMessages(true));
      return;
    }

    if (this.is未確定表示中_明細あり) {
      this.確認ダイアログを開く('編集中Excel出力確認ダイアログ');
    } else {
      this.確認ダイアログを開く('Excel出力確認ダイアログ');
    }
  }

  async 確認ダイアログを閉じて棚卸一覧表の出力(): Promise<void> {
    this.確認ダイアログを閉じる('Excel出力確認ダイアログ');
    await progress(this.棚卸一覧表の出力);
  }

  async 確認ダイアログを閉じて編集中棚卸一覧表の出力(): Promise<void> {
    this.確認ダイアログを閉じる('編集中Excel出力確認ダイアログ');
    await progress(this.棚卸一覧表の出力);
  }

  async 棚卸一覧表の出力(): Promise<void> {
    if (this.棚卸検索条件.棚卸年月日 === null) {
      return;
    }
    if (this.取得済棚卸情報 === null) {
      return;
    }

    if (this.is未確定表示中_明細あり) {
      // FIXME リファクタリング
      const 棚卸明細保存依頼: 棚卸明細行保存依頼型[] =
        this.取得済棚卸情報.明細一覧.map((明細: 棚卸明細型) => {
          return {
            商品コード: 明細.棚卸商品.商品コード,
            有効期限: this.customFormat(明細.棚卸在庫.有効期限),
            在庫区分: 明細.棚卸在庫.在庫区分,
            棚名: 明細.棚番設定.棚名,
            棚番号: 明細.棚番設定.棚番号,
            箱数: 明細.棚卸在庫.実在庫.箱数,
            バラ数: 明細.棚卸在庫.実在庫.バラ数,
            更新バージョン: 明細.更新バージョン,
            理論在庫換算数: 明細.棚卸在庫.理論在庫.在庫換算数,
            実在庫換算数: 明細.棚卸在庫.実在庫.在庫換算数,
          };
        });

      const 有効期限あり棚卸明細: 有効期限あり棚卸明細行型[] =
        this.取得済棚卸情報.有効期限あり明細一覧.map((明細: 棚卸明細型) => {
          return {
            商品コード: 明細.棚卸商品.商品コード,
            有効期限: this.customFormat(明細.棚卸在庫.有効期限),
            在庫区分: 明細.棚卸在庫.在庫区分,
            棚名: 明細.棚番設定.棚名,
            棚番号: 明細.棚番設定.棚番号,
            理論在庫換算数: 明細.棚卸在庫.理論在庫.在庫換算数,
            更新バージョン: 明細.更新バージョン,
          };
        });

      const 棚卸保存依頼: 棚卸保存依頼型 = {
        棚卸番号: this.取得済棚卸情報.ヘッダー.棚卸番号,
        部署コード: this.取得済棚卸情報.ヘッダー.部署コード,
        棚卸日付: this.customFormat(this.取得済棚卸情報.ヘッダー.棚卸日付),
        棚卸明細: 棚卸明細保存依頼,
        有効期限あり棚卸明細,
      };

      try {
        await this.api.棚卸を保存する(棚卸保存依頼);
      } catch (error) {
        this.APIアラートメッセージを表示する(error);
      }
    }

    const 棚卸一覧出力条件 = {
      部署コード: this.取得時棚卸検索条件.在庫場所,
      棚卸年月日: this.取得時棚卸検索条件.棚卸年月日,
      棚名検索条件: this.取得時棚卸検索条件.棚名検索条件,
      棚番号検索条件: this.取得時棚卸検索条件.棚番号検索条件,
      棚名有無検索条件: this.取得時棚卸検索条件.棚名有無検索条件,
      理論在庫有無検索条件: this.取得時棚卸検索条件.理論在庫有無検索条件,
      使用区分検索条件: this.取得時棚卸検索条件.使用区分検索条件,
      商品名カナ検索条件: this.取得時棚卸検索条件.商品名カナ検索条件,
      メーカー名検索条件: this.取得時棚卸検索条件.メーカー名検索条件,
      並順区分検索条件: this.取得時棚卸検索条件.並順区分検索条件,
    };

    await this.api.棚卸一覧表を出力する('棚卸一覧.xlsx', 棚卸一覧出力条件);

    if (this.is未確定表示中_明細あり) {
      this.クリア();
    }
  }

  棚卸表の印刷確認(): void {
    this.確認ダイアログを開く('印刷確認ダイアログ');
  }

  async 確認ダイアログを閉じて棚卸表を印刷する(): Promise<void> {
    this.確認ダイアログを閉じる('印刷確認ダイアログ');
    await progress(this.棚卸表の印刷);
  }

  async 棚卸表の印刷(): Promise<void> {
    if (this.取得時棚卸検索条件.棚卸年月日 === null) {
      return;
    }

    const ファイル名 = this.ファイル名を取得する();
    const 棚卸表出力条件 = {
      部署コード: this.取得時棚卸検索条件.在庫場所,
      棚卸年月日: this.取得時棚卸検索条件.棚卸年月日,
      棚名検索条件: this.取得時棚卸検索条件.棚名検索条件,
      棚番号検索条件: this.取得時棚卸検索条件.棚番号検索条件,
      棚名有無検索条件: this.取得時棚卸検索条件.棚名有無検索条件,
      理論在庫有無検索条件: this.取得時棚卸検索条件.理論在庫有無検索条件,
      使用区分検索条件: this.取得時棚卸検索条件.使用区分検索条件,
      商品名カナ検索条件: this.取得時棚卸検索条件.商品名カナ検索条件,
      メーカー名検索条件: this.取得時棚卸検索条件.メーカー名検索条件,
      並順区分検索条件: this.取得時棚卸検索条件.並順区分検索条件,
    };
    await this.api.棚卸表帳票を出力する(ファイル名, 棚卸表出力条件);
  }

  ファイル名を取得する(): string {
    const now = new Date();
    moment.locale('ja');
    return '棚卸表_' + moment(now).format('YYYYMMDDhhmmss') + '.pdf';
  }

  棚卸情報の再計算確認(): void {
    const result = this.棚卸入力の入力検証();
    if (result.hasErrors) {
      this.アラートダイアログを表示する(result.getMessages(true));
      return;
    }

    this.確認ダイアログを開く('再計算確認ダイアログ');
  }

  async 確認ダイアログを閉じて棚卸を再計算する(): Promise<void> {
    this.確認ダイアログを閉じる('再計算確認ダイアログ');
    await progress(this.棚卸情報の再計算);
  }

  async 棚卸情報の再計算(): Promise<void> {
    if (this.取得済棚卸情報 === null) {
      return;
    }

    const 棚卸明細再計算依頼: 棚卸明細行再計算依頼型[] =
      this.取得済棚卸情報.明細一覧.map((明細: 棚卸明細型) => {
        return {
          商品コード: 明細.棚卸商品.商品コード,
          有効期限: this.customFormat(明細.棚卸在庫.有効期限),
          在庫区分: 明細.棚卸在庫.在庫区分,
          棚名: 明細.棚番設定.棚名,
          棚番号: 明細.棚番設定.棚番号,
          箱数: 明細.棚卸在庫.実在庫.箱数,
          バラ数: 明細.棚卸在庫.実在庫.バラ数,
          更新バージョン: 明細.更新バージョン,
          理論在庫換算数: 明細.棚卸在庫.理論在庫.在庫換算数,
          実在庫換算数: 明細.棚卸在庫.実在庫.在庫換算数,
        };
      });

    const 有効期限あり棚卸明細: 有効期限あり棚卸明細行型[] =
      this.取得済棚卸情報.有効期限あり明細一覧.map((明細: 棚卸明細型) => {
        return {
          商品コード: 明細.棚卸商品.商品コード,
          有効期限: this.customFormat(明細.棚卸在庫.有効期限),
          在庫区分: 明細.棚卸在庫.在庫区分,
          棚名: 明細.棚番設定.棚名,
          棚番号: 明細.棚番設定.棚番号,
          理論在庫換算数: 明細.棚卸在庫.理論在庫.在庫換算数,
          更新バージョン: 明細.更新バージョン,
        };
      });

    const 棚卸再計算依頼: 棚卸再計算依頼型 = {
      棚卸明細: 棚卸明細再計算依頼,
      有効期限あり棚卸明細,
    };

    try {
      await this.api.棚卸を再計算する(this.取得済棚卸情報.ヘッダー.棚卸番号, 棚卸再計算依頼);
      await this.棚卸情報の絞込み検索();
      this.完了ダイアログを表示する('棚卸情報の再計算が完了しました。');
    } catch (error) {
      this.APIアラートメッセージを表示する(error);
    }
  }

  理論在庫の値を実在庫に入れる(): void {
    this.取得済棚卸明細 = this.取得済棚卸明細.map((明細: 棚卸明細型) => {
      if (明細.棚卸在庫.理論在庫.バラ数 > 0) {
        明細.棚卸在庫.実在庫.バラ数 = 明細.棚卸在庫.理論在庫.バラ数;
      } else {
        明細.棚卸在庫.実在庫.バラ数 = 0;
      }
      if (明細.棚卸在庫.理論在庫.箱数 > 0) {
        明細.棚卸在庫.実在庫.箱数 = 明細.棚卸在庫.理論在庫.箱数;
      } else {
        明細.棚卸在庫.実在庫.箱数 = 0;
      }
      return 明細;
    });
  }

  メニューに戻る確認(): void {
    if (viewEditingStateModule.画面を編集中である) {
      this.確認ダイアログを開く('編集中メニューに戻る確認ダイアログ');
    } else {
      this.確認ダイアログを開く('メニューに戻る確認ダイアログ');
    }
  }

  メニューに戻る(): void {
    this.$router.push({name: 'home'});
  }

  クリアの確認(): void {
    if (viewEditingStateModule.画面を編集中である) {
      this.確認ダイアログを開く('編集中クリア確認ダイアログ');
    } else {
      this.確認ダイアログを開く('クリア確認ダイアログ');
    }
  }

  確認ダイアログを閉じてクリアする(ダイアログ名: string): void {
    this.確認ダイアログを閉じる(ダイアログ名);
    this.クリア();
  }

  クリア(): void {
    this.取得済棚卸情報 = null;
    this.取込可能ハンディ棚卸情報件数 = 0;

    this.棚卸検索条件.絞込み条件のクリア();
    this.取得時棚卸検索条件.絞込み条件のクリア();
  }

  customFormat(date: Date | null): string {
    // TODO 日付のフォーマットは表示時だけfilterを使い、dataはDateとして持つ方が良い
    if (date === null) {
      return '';
    }
    return moment(date).format('YYYY-MM-DD');
  }

  APIアラートメッセージを取得(data: any): string[] {
    let メッセージ = [data.message];
    if (!data.errors) {
      return メッセージ;
    }

    for (const エラー of data.errors) {
      メッセージ = メッセージ.concat(['・' + エラー]);
    }
    return メッセージ;
  }

  APIアラートメッセージを表示する(error: any): void {
    const APIアラートメッセージ = this.APIアラートメッセージを取得(error.data);
    this.アラートダイアログを表示する(APIアラートメッセージ);
  }

  async setDerivedValue(event: any): Promise<void> {
    if (this.取得済棚卸情報 === null) {
      return;
    }

    const 明細 = this.取得済棚卸情報.明細一覧[event.行番号];
    明細.棚卸在庫.実在庫.在庫換算数 = event.実在庫換算数;
    明細.在庫金額.実在庫 = event.実在庫金額;
    明細.棚卸在庫.差数 = event.差数;

    viewEditingStateModule.画面の編集を開始する();
  }

  // lifecycle hooks
  created(): void {
    if (this.函館五稜郭病院仕様である) {
      this.api = new GoryoukakuStocktakingApi();
    } else {
      this.api = new StandardStocktakingApi();
    }
    this.初期化処理();
  }
}
